"use client"

import { useState } from "react"
import { useNavigate, useParams, Link } from "react-router-dom"
import { b2cForgotPassword, b2cResetPassword } from "../api/b2cUserApi"
import Swal from "sweetalert2"

const ForgotPassword = () => {
  const navigate = useNavigate()
  const { companyName } = useParams()

  const [step, setStep] = useState(1) // 1 = email form, 2 = reset form
  const [email, setEmail] = useState("")
  const [otp, setOtp] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const handleForgotPassword = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const response = await b2cForgotPassword(email)
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: response.message,
        })
        setStep(2)
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message || "Failed to send OTP",
        })
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message || "An error occurred",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleResetPassword = async (e) => {
    e.preventDefault()

    if (newPassword !== confirmPassword) {
      Swal.fire({ icon: "error", title: "Validation Error", text: "Passwords do not match" })
      return
    }

    setLoading(true)
    try {
      const response = await b2cResetPassword(email, otp, newPassword)
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message,
          timer: 2000,
          showConfirmButton: false,
        })
        setTimeout(() => navigate(`/${companyName}/login`), 2000)
      } else {
        Swal.fire({ icon: "error", title: "Error", text: response.message || "Failed to reset password" })
      }
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err.message || "An error occurred" })
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="features py-5">
      <div className="container-lg">
        <div className="row g-4 justify-content-center">
          <div className="col-lg-5">
            <div className="info-card">
              {step === 1 ? (
                <>
                  <h4 className="fw-bold mb-3">Forgot Password</h4>
                  <p className="text-muted mb-4">
                    Enter your email address and we'll send you an OTP to reset your password.
                  </p>
                  <form onSubmit={handleForgotPassword}>
                    <div className="mb-3">
                      <label className="form-label">Email Address</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-primary-navy w-100" disabled={loading}>
                      {loading ? "Sending..." : "Send OTP"}
                    </button>
                    <div className="text-center mt-3">
                      <Link
                        to={`/${companyName}/login`}
                        className="fw-bold"
                        style={{ color: "#002B5C", textDecoration: "none" }}
                      >
                        Back to Login
                      </Link>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <h4 className="fw-bold mb-3">Reset Password</h4>
                  <p className="text-muted mb-4">
                    Enter the OTP sent to <strong>{email}</strong> and your new password.
                  </p>
                  <form onSubmit={handleResetPassword}>
                    <div className="mb-3">
                      <label className="form-label">OTP</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter 6-digit OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Confirm New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-primary-navy w-100" disabled={loading}>
                      {loading ? "Resetting..." : "Reset Password"}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ForgotPassword
